module.exports = __webpack_public_path__ + "public/images/programming.cc728955a470d7bf96bbcefb6f1eff54.png";